<template>
  <div>
    <div class="pageTypeA" v-if="pageType==1&&dataObj">
      <div  class="instructionsPdf">
        <div :style="'background:#'+dataObj.template1.colorCode1+';'" class="instructionsPdf_head">

        </div>
        <div class="instructionsPdf_body">
          <div :style="'background:#'+dataObj.template1.colorCode2+';'" class="instructionsPdf_body_bgImgA">
          </div>
          <div :style="'background:#'+dataObj.template1.colorCode3+';'" class="instructionsPdf_body_bgImgB">
            <div class="instructionsPdf_body_bgImgB_img">
              <img class="wh100" :src="dataObj.template1.lowerRightLogo" alt="" />
            </div>
          </div>
          <div class="instructionsPdf_body_top">
            <div class="instructionsPdf_body_top_ewmImg a_flex">

            </div>
            <div class="instructionsPdf_body_top_icon a_flex">
              <img class="wh100" src="https://image.giantgocloud.com/www/ImageMapping/image/20250402/E35A24E8CA564A5BAF9EBF2C4429173C.png"  />
            </div>
            <div class="instructionsPdf_body_top_text">
              扫描二维码，了解您的专属产品更多详情。
            </div>
          </div>
          <div class="instructionsPdf_body_box">
            <div class="instructionsPdf_body_box_bgImg a_flex">
              <img class="wh100" :src="dataObj.firstPage.centerLogo" />
            </div>

            <div v-for="(item,index) in listData" :key="index"  >
              <!-- v-if="!item.typeA||item.effect.length" -->
              <div  class="instructionsPdf_body_box_li" >
                <template v-if="item.typeA">
                  <div class="instructionsPdf_body_box_li_bgImg a_flex">
                    <img class="wh100" :src="item.bgImg" />
                  </div>

                  <div class="instructionsPdf_body_box_li_top">
                    <div class="instructionsPdf_body_box_li_top_icon a_flex">
                      <img class="wh100" src="https://image.giantgocloud.com/www/ImageMapping/image/20250402/EFE61EFE4625472984CE5F4705497341.png" />
                    </div>
                    <div class="instructionsPdf_body_box_li_top_title">
                      {{item.productName}}
                    </div>
                  </div>
                  <div class="instructionsPdf_body_box_li_ul">
                    <div v-for="(item1,index1) in item.effect" :key="index1" class="instructionsPdf_body_box_li_ul_li">
                      <div class="instructionsPdf_body_box_li_ul_li_i"></div>
                      <div class="instructionsPdf_body_box_li_ul_li_text">
                        {{item1.effect}}：{{item1.ingredient}}
                      </div>
                    </div>
                  </div>
                </template>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div  class="instructionsPdfA">
        <div class="instructionsPdfA_oneBox">
          <div class="instructionsPdfA_oneBox_left">
            <div class="instructionsPdfA_oneBox_left_title">
              {{dataObj.secendPage.title}}
            </div>
            <div class="instructionsPdfA_oneBox_left_info">
              {{dataObj.secendPage.welcomeMessage}}
            </div>
            <div class="instructionsPdfA_oneBox_left_text">
             {{dataObj.secendPage.companyIntroduce}}
            </div>
            <div class="instructionsPdfA_oneBox_left_img a_flex">
              <img class="wh100" :src="dataObj.secendPage.centerLogo" />
            </div>
          </div>
          <div class="instructionsPdfA_oneBox_right">
            <div class="instructionsPdfA_oneBox_top">
              <div class="instructionsPdfA_oneBox_top_title">
                {{dataObj.secendPage.programName}}
              </div>
              <div class="instructionsPdfA_oneBox_top_text">
                {{dataObj.secendPage.programIntroduce}}
              </div>
            </div>
            <div class="instructionsPdfA_oneBox_prduct">
              <div class="instructionsPdfA_oneBox_prduct_title a_flex">
                {{dataObj.secendPage.productTitle}}
              </div>
              <div class="instructionsPdfA_oneBox_prduct_ul">
                <div v-for="(item,index) in dataObj.secendPage.productDescribeList" :key="index" class="instructionsPdfA_oneBox_prduct_li">
                  <div class="instructionsPdfA_oneBox_prduct_li_img a_flex">
                    <img style="height: 60%;" :src="item.productPic" />
                  </div>
                  <div class="instructionsPdfA_oneBox_prduct_li_infoA a_flex">
                    {{item.productName}}
                  </div>
                  <div class="instructionsPdfA_oneBox_prduct_li_infoB a_flex">
                    {{item.usageTitle}}
                  </div>
                  <div class="instructionsPdfA_oneBox_prduct_li_infoC a_flex">
                    {{item.productUsage}}
                  </div>
                </div>
              </div>
              <div class="instructionsPdfA_infoBox_info" >
                <div v-for="(item,index) in dataObj.secendPage.useageNotice" :key="index">
                  {{item}}
                </div>
              </div>
              <div class="instructionsPdfA_infoBox_bottom">
                <div class="instructionsPdfA_infoBox_bottom_title">
                  <div class="instructionsPdfA_infoBox_bottom_title_icon a_flex">
                    <img class="wh100" src="https://image.giantgocloud.com/www/ImageMapping/image/20250408/7F214F765866425E9981CF65C3482413.png" />
                  </div>
                  <div class="instructionsPdfA_infoBox_bottom_title_text">{{dataObj.secendPage.noticeTitle}}</div>
                </div>
                <div class="instructionsPdfA_infoBox_bottom_ul">
                  <div v-for="(item,index) in dataObj.secendPage.otherNotices" class="instructionsPdfA_infoBox_bottom_li">
                    {{item}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="instructionsPdfA_twoBox">
          <div class="instructionsPdfA_twoBox_left">
            <div class="instructionsPdfA_twoBox_left_info">
              <div class="instructionsPdfA_twoBox_left_info_title">
                  <font class="instructionsPdfA_twoBox_left_info_Hi">Hi </font> {{dataObj.secendPage.footPlate.userName}}
              </div>
              <div class="instructionsPdfA_twoBox_left_info_center">
                <div class="instructionsPdfA_twoBox_left_info_center_left">
       <!--           <div class="instructionsPdfA_twoBox_left_info_center_left_textA">
                    {{dataObj.secendPage.footPlate.projectName}}
                  </div> -->
                  <div class="instructionsPdfA_twoBox_left_info_center_left_textB">
                    {{dataObj.secendPage.footPlate.projectTitle}}
                  </div>
                </div>
                <div class="instructionsPdfA_twoBox_left_info_center_icon a_flex">
                  <img class="wh100" :src="dataObj.secendPage.footPlate.projectPic" />
                </div>
              </div>
            <!--  <div class="instructionsPdfA_twoBox_left_info_bottom">
                <div class="instructionsPdfA_twoBox_left_info_bottom_icon a_flex">
                  <img class="wh100" src="https://image.giantgocloud.com/www/ImageMapping/image/20250408/C7D2C054C94F4F159C07B135A9FFB126.png" />
                </div>
                <div class="instructionsPdfA_twoBox_left_info_bottom_icon_right">
                  <div v-for="(item,index) in dataObj.secendPage.footPlate.projectNotices" :key='index' class="instructionsPdfA_twoBox_left_info_bottom_icon_right_text">{{item}}</div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="instructionsPdfA_twoBox_right">
            <div class="instructionsPdfA_twoBox_right_img a_flex">
              <img class="wh100" :src="dataObj.secendPage.footLogo2" />
            </div>
          </div>
        </div>
        <div class="instructionsPdfA_three" :style="'background:#'+dataObj.template1.colorCode4+';'">
          <div class="instructionsPdfA_three_img a_flex">
            <img class="wh100" :src="dataObj.secendPage.footLogo3" />
          </div>
        </div>
      </div>
    </div>
    <div class="pageTypeB" v-if="pageType==2&&dataObj">
      <div  class="instructionsPdf">
        <div  class="instructionsPdf_head" :style="'background:#'+dataObj.template2.colorCode3+';'">
          <div class="instructionsPdf_head_A" :style="'background:#'+dataObj.template2.colorCode1+';'"></div>
          <div class="instructionsPdf_head_B" :style="'background:#'+dataObj.template2.colorCode2+';'"></div>
          <div class="instructionsPdf_head_C" :style="'background:#'+dataObj.template2.colorCode3+';'"></div>
        </div>
        <div class="instructionsPdf_body">

          <div class="instructionsPdf_body_top">

            <div class="instructionsPdf_body_top_icon a_flex">
              <img class="wh100" src="https://image.giantgocloud.com/www/ImageMapping/image/20250402/E35A24E8CA564A5BAF9EBF2C4429173C.png"  />
            </div>
            <div class="instructionsPdf_body_top_text">
              扫描二维码，了解您的专属产品更多详情。
            </div>
            <div class="instructionsPdf_body_top_ewmImg a_flex">

            </div>
          </div>
          <div class="instructionsPdf_body_box">
            <div class="instructionsPdf_body_box_bgImg a_flex">
              <img class="wh100" :src="dataObj.firstPage.centerLogo" />
            </div>

            <div v-for="(item,index) in listData" :key="index"  >
              <!-- v-if="!item.typeA||item.effect.length" -->
              <div  class="instructionsPdf_body_box_li" >
                <template v-if="item.typeA">
                  <div class="instructionsPdf_body_box_li_bgImg a_flex">
                    <img class="wh100" :src="item.bgImg" />
                  </div>

                  <div class="instructionsPdf_body_box_li_top">
                    <div class="instructionsPdf_body_box_li_top_icon a_flex">
                      <img class="wh100" src="https://image.giantgocloud.com/www/ImageMapping/image/20250402/EFE61EFE4625472984CE5F4705497341.png" />
                    </div>
                    <div class="instructionsPdf_body_box_li_top_title">
                      {{item.productName}}
                    </div>
                  </div>
                  <div class="instructionsPdf_body_box_li_ul">
                    <div v-for="(item1,index1) in item.effect" :key="index1" class="instructionsPdf_body_box_li_ul_li">
                      <div class="instructionsPdf_body_box_li_ul_li_i"></div>
                      <div class="instructionsPdf_body_box_li_ul_li_text">
                        {{item1.effect}}：{{item1.ingredient}}
                      </div>
                    </div>
                  </div>
                </template>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div  class="instructionsPdfA">
        <div class="instructionsPdfARightT" :style="'background:#'+dataObj.template2.colorCode3+';'">
          <div class="instructionsPdfARightT_A" :style="'background:#'+dataObj.template2.colorCode1+';'">
            <div class="instructionsPdfARightT_AA a_flex" :style="'background:#'+dataObj.template2.colorCode1+';'">
              <div class="instructionsPdfARightT_AA_img a_flex">
                <img class="wh100" :src="dataObj.template2.rightLogo"  />
              </div>
            </div>
          </div>
          <div class="instructionsPdfARightT_B" :style="'background:#'+dataObj.template2.colorCode2+';'"></div>
          <div class="instructionsPdfARightT_C" :style="'background:#'+dataObj.template2.colorCode3+';'"></div>
        </div>
        <div class="instructionsPdfA_oneBox">
          <div class="instructionsPdfA_oneBox_left">
            <div class="instructionsPdfA_oneBox_left_title">
              {{dataObj.secendPage.title}}
            </div>
            <div class="instructionsPdfA_oneBox_left_info">
              {{dataObj.secendPage.welcomeMessage}}
            </div>
            <div class="instructionsPdfA_oneBox_left_text">
             {{dataObj.secendPage.companyIntroduce}}
            </div>
            <div class="instructionsPdfA_oneBox_left_img a_flex">
              <img class="wh100" :src="dataObj.secendPage.centerLogo" />
            </div>
          </div>
          <div class="instructionsPdfA_oneBox_right">
            <div class="instructionsPdfA_oneBox_top">
              <div class="instructionsPdfA_oneBox_top_title">
                {{dataObj.secendPage.programName}}
              </div>
              <div class="instructionsPdfA_oneBox_top_text">
                {{dataObj.secendPage.programIntroduce}}
              </div>
            </div>
            <div class="instructionsPdfA_oneBox_prduct">
              <div class="instructionsPdfA_oneBox_prduct_title a_flex">
                {{dataObj.secendPage.productTitle}}
              </div>
              <div class="instructionsPdfA_oneBox_prduct_ul">
                <div v-for="(item,index) in dataObj.secendPage.productDescribeList" :key="index" class="instructionsPdfA_oneBox_prduct_li">
                  <div class="instructionsPdfA_oneBox_prduct_li_img a_flex">
                    <img style="height: 60%;" :src="item.productPic" />
                  </div>
                  <div class="instructionsPdfA_oneBox_prduct_li_infoA a_flex">
                    {{item.productName}}
                  </div>
                  <div class="instructionsPdfA_oneBox_prduct_li_infoB a_flex">
                    {{item.usageTitle}}
                  </div>
                  <div class="instructionsPdfA_oneBox_prduct_li_infoC a_flex">
                    {{item.productUsage}}
                  </div>
                </div>
              </div>
              <div class="instructionsPdfA_infoBox_info" >
                <div v-for="(item,index) in dataObj.secendPage.useageNotice" :key="index">
                  {{item}}
                </div>
              </div>
              <div class="instructionsPdfA_infoBox_bottom">
                <div class="instructionsPdfA_infoBox_bottom_title">
                  <div class="instructionsPdfA_infoBox_bottom_title_icon a_flex">
                    <img class="wh100" src="https://image.giantgocloud.com/www/ImageMapping/image/20250408/7F214F765866425E9981CF65C3482413.png" />
                  </div>
                  <div class="instructionsPdfA_infoBox_bottom_title_text">{{dataObj.secendPage.noticeTitle}}</div>
                </div>
                <div class="instructionsPdfA_infoBox_bottom_ul">
                  <div v-for="(item,index) in dataObj.secendPage.otherNotices" :key="index" class="instructionsPdfA_infoBox_bottom_li">
                    {{item}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="instructionsPdfA_twoBox">
          <div class="instructionsPdfA_twoBox_left">
            <div class="instructionsPdfA_twoBox_left_info">
              <div class="instructionsPdfA_twoBox_left_info_title">
                  <font class="instructionsPdfA_twoBox_left_info_Hi">Hi </font> {{dataObj.secendPage.footPlate.userName}}
              </div>
              <div class="instructionsPdfA_twoBox_left_info_center">
                <div class="instructionsPdfA_twoBox_left_info_center_left">
                 <!-- <div class="instructionsPdfA_twoBox_left_info_center_left_textA">
                    {{dataObj.secendPage.footPlate.projectName}}
                  </div> -->
                  <div class="instructionsPdfA_twoBox_left_info_center_left_textB">
                    {{dataObj.secendPage.footPlate.projectTitle}}
                  </div>
                </div>
                <div class="instructionsPdfA_twoBox_left_info_center_icon a_flex">
                  <img class="wh100" :src="dataObj.secendPage.footPlate.projectPic" />
                </div>
              </div>
          <!--    <div class="instructionsPdfA_twoBox_left_info_bottom">
                <div class="instructionsPdfA_twoBox_left_info_bottom_icon a_flex">
                  <img class="wh100" src="https://image.giantgocloud.com/www/ImageMapping/image/20250408/C7D2C054C94F4F159C07B135A9FFB126.png" />
                </div>
                <div class="instructionsPdfA_twoBox_left_info_bottom_icon_right">
                  <div v-for="(item,index) in dataObj.secendPage.footPlate.projectNotices" :key='index' class="instructionsPdfA_twoBox_left_info_bottom_icon_right_text">{{item}}</div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="instructionsPdfA_twoBox_right">
            <div class="instructionsPdfA_twoBox_right_img a_flex">
              <img class="wh100" :src="dataObj.secendPage.footLogo2" />
            </div>
          </div>
        </div>
        <div class="instructionsPdfA_three" >
          <div class="instructionsPdfA_three_img a_flex">
            <img class="wh100" :src="dataObj.secendPage.footLogo3" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import H5Report from '@/api/index'
export default {
  data () {
    return {
      pageType: -1,
      dataObj: '',
      orderId: '',
      listData: [
        {
          bgImg: 'https://image.giantgocloud.com/www/ImageMapping/image/20250402/F3AC5CF5BB9F4CA1991C6810EDE3BDAA.png',
          typeA: true,
          productName: '',
          effect: []
        },
        {
          bgImg: 'https://image.giantgocloud.com/www/ImageMapping/image/20250402/5F9C90DE325042E59AB47AA8D4B489DC.png',
          typeA: true,
          productName: '',
          effect: []
        },
        {
          bgImg: 'https://image.giantgocloud.com/www/ImageMapping/image/20250402/7651571022CF4107A34D93EACD5D6177.png',
          typeA: true,
          productName: '',
          effect: []
        },
        {
          bgImg: 'https://image.giantgocloud.com/www/ImageMapping/image/20250402/AD90D7CE93D5457D8BED06C4890088F1.png',
          typeA: true,
          productName: '',
          effect: []
        },
        {
          bgImg: '',
          typeA: false,
          productName: '',
          effect: []
        },
        {
          bgImg: 'https://image.giantgocloud.com/www/ImageMapping/image/20250402/7C697EB6C1F04183A51447BB2664B3EC.png',
          typeA: true,
          productName: '',
          effect: []
        },
        {
          bgImg: 'https://image.giantgocloud.com/www/ImageMapping/image/20250402/3805AA5621314672AB24590C327B58E8.png',
          typeA: true,
          productName: '',
          effect: []
        },
        {
          bgImg: '',
          typeA: false,
          productName: '',
          effect: []
        },
        {
          bgImg: 'https://image.giantgocloud.com/www/ImageMapping/image/20250402/8559C14BE13B43318D658A7F08689E17.png',
          typeA: true,
          productName: '',
          effect: []
        },
        {
          bgImg: 'https://image.giantgocloud.com/www/ImageMapping/image/20250402/476F870AE0FE41E5A03843312E92124F.png',
          typeA: true,
          productName: '',
          effect: []
        },
        {
          bgImg: 'https://image.giantgocloud.com/www/ImageMapping/image/20250402/1740FAB080F448ECAA3DB4DABE534F34.png',
          typeA: true,
          productName: '',
          effect: []
        },
        {
          bgImg: 'https://image.giantgocloud.com/www/ImageMapping/image/20250402/259EA7E909244698AE88BAA9BB27B9D6.png',
          typeA: true,
          productName: '',
          effect: []
        }
      ]
    }
  },
  mounted () {
    const that = this
    // console.log('this.$route.query', this.$route)
    this.pageType = this.$route.query.pageType
    this.orderId = this.$route.query.orderId
    axios
      .post(
        `${H5Report}/boardApi/CustomScheme/GetOrderInstructionsReport`,
        {
          OrderId: that.orderId,
          TypeId: this.pageType
        }
      )
      .then((e) => {
        console.log('GetOrderInstructionsReport', e)
        const AA = e.data.data
        let indexA = 0
        for (let i = 0; i < AA.firstPage.productList.length; i++) {
          if (!that.listData[indexA].typeA) {
            that.listData[indexA].productName = ''
            that.listData[indexA].effect = []
            indexA++
          }
          if (AA.firstPage.productList[i].effect) {
            that.listData[indexA].productName = AA.firstPage.productList[i].productName
            that.listData[indexA].effect = AA.firstPage.productList[i].effect
            indexA++
          } else {
            that.listData[indexA].productName = ''
            that.listData[indexA].effect = []
          }
        }
        that.dataObj = AA
        console.log('that.dataObj', that.dataObj)
        console.log('that.listData', that.listData)
      })
  }
}
</script>

<style lang="scss" scoped>
  div {
    box-sizing: border-box;
  }
  @import '@/views/instructionsPdf/instructionsPdfNewA.scss';
  @import '@/views/instructionsPdf/instructionsPdfNewB.scss';

</style>
